"use strict";
export function getHandleOnUpdateDelegatedState(ctx) {
  const { getOriginalState, getState, logger } = ctx;
  function handleOnUpdateDelegatedState(input) {
    const { action } = input;
    logger?.debug(
      "effects.ts",
      "handleOnUpdateDelegatedState",
      `Updating delegated state for chain id ${action.payload.chainId}`
    );
    const originalState = getOriginalState();
    const currentState = getState();
    const delegatedState = originalState.wallets.delegatedState;
    const isNewDelegatedState = !delegatedState[action.payload.chainId] || delegatedState[action.payload.chainId] !== action.payload.address;
    const activeChainId = currentState.wallets.activeChainId?.toString();
    const isActiveChain = (chainId) => activeChainId === chainId;
    if (isNewDelegatedState) {
      logger?.info(
        "effects.ts",
        "handleOnUpdateDelegatedState",
        `New delegated state detected for chain id ${JSON.stringify(action.payload)}`
      );
      ctx.onNewDelegateState({
        delegations: currentState.wallets.delegatedState
      });
      logger?.info(
        "effects.ts",
        "handleOnUpdateDelegatedState",
        `Tracking delegation detected event for chain id ${JSON.stringify(action.payload)}`
      );
      ctx.onDelegationDetected({
        chainId: parseInt(action.payload.chainId, 10),
        address: action.payload.address,
        isActiveChain: isActiveChain(action.payload.chainId)
      });
    }
  }
  return handleOnUpdateDelegatedState;
}
export function getHandleOnSetActiveChainId(ctx) {
  const { getState, logger } = ctx;
  function handleOnSetActiveChainId(input) {
    const { action } = input;
    if (action.payload.chainId) {
      const chainId = action.payload.chainId.toString();
      const state = getState();
      const delegationAddress = state.wallets.delegatedState[chainId];
      if (delegationAddress) {
        logger?.info("effects.ts", "handleOnSetActiveChainId", `Delegation address found for chain id ${chainId}`);
        ctx.onDelegationDetected({
          chainId: parseInt(chainId, 10),
          address: delegationAddress,
          isActiveChain: true
        });
      }
    }
  }
  return handleOnSetActiveChainId;
}
